module.exports = __webpack_public_path__ + "static/media/5.41bc5cf5.png";